import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22185 22183"
    {...props}
  >
    <path
      d="M3336 3336C5321 1351 8063 123 11093 123c3029 0 5771 1228 7757 3213l334 349-1974 11c-1661-1375-3793-2202-6117-2202-2359 0-4520 852-6191 2262l-1974 10 408-430zm17519 2748c771 1502 1207 3204 1207 5009 0 3029-1228 5772-3212 7757-1866 1865-4400 3062-7212 3199l362-628 479-829c2096-303 3973-1284 5401-2712 1737-1737 2811-4137 2811-6787 0-1254-241-2452-678-3551l842-1458zM4305 17880c1391 1391 3206 2357 5235 2687l483 846 358 627c-2746-176-5217-1362-7045-3190-1985-1985-3213-4728-3213-7757 0-1784 425-3468 1181-4957l841 1474c-420 1080-651 2254-651 3483 0 2650 1075 5050 2811 6787z"
      style={{
        fill: "#2b2a29",
        stroke: "#2b2a29",
        strokeWidth: 245.851,
      }}
      className="stroke1 fill"
    />
  </svg>
)
export default SvgComponent
